module.exports = __webpack_public_path__ + "img/logo.5a7c4f2b.png";